import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { splitText } from "./utils/splitText";

const initTextReveals = () => {
	if (window.innerWidth < 1024) return;
	const textElements = gsap.utils.toArray("h1, h2, h3, p");
	const buttonElements = gsap.utils.toArray(".button-primary");
	const cardElements = gsap.utils.toArray(".event-card, .event-card-minimal, .business-card");
	const imageRevealElements = gsap.utils.toArray(".image-reveal");
	const heroSection = document.getElementById("home-hero-section");
	const footer = document.getElementById("footer");

	// Filter out hero, footer, and card elements
	const filteredElements = textElements.filter(
		(element) =>
			!(
				heroSection?.contains(element) ||
				footer?.contains(element) ||
				cardElements.some((card) => card.contains(element))
			),
	);

	// Create individual ScrollTrigger for each text element
	filteredElements.forEach((element) => {
		const split = splitText([element])[0];

		ScrollTrigger.create({
			trigger: element,
			start: "top bottom",
			once: true,
			onEnter: () => {
				if (split.lines && split.lines.length > 0) {
					gsap.to(split.lines, {
						opacity: 1,
						yPercent: 0,
						duration: 1.4,
						stagger: 0.1,
						ease: "power3.out",
					});
				}
			},
			invalidateOnRefresh: true,
		});
	});

	// Create individual ScrollTrigger for buttons and cards
	[...buttonElements, ...cardElements, ...imageRevealElements].forEach((element) => {
		gsap.set(element, { opacity: 0, y: 60 });

		ScrollTrigger.create({
			trigger: element,
			start: "top bottom",
			once: true,
			onEnter: () => {
				gsap.to(element, {
					opacity: 1,
					y: 0,
					duration: 1.4,
					ease: "power3.out",
				});
			},
			invalidateOnRefresh: true,
		});
	});
};

export default initTextReveals;
